
import { ClientTherapistRelationship } from "@/types/therapist";

export const useDisplayFormatting = () => {
  const formatDate = (dateString: string) => {
    const options: Intl.DateTimeFormatOptions = { 
      year: 'numeric', 
      month: 'long', 
      day: 'numeric'
    };
    return new Date(dateString).toLocaleDateString(undefined, options);
  };

  const getClientDisplayName = (client?: ClientTherapistRelationship['client']) => {
    if (!client) return "Unknown Client";
    
    if (client.profile) {
      if (client.profile.first_name || client.profile.last_name) {
        const name = `${client.profile.first_name || ''} ${client.profile.last_name || ''}`.trim();
        if (name) return name;
      }
      
      if (client.profile.company) {
        return client.profile.company;
      }
    }
    
    if (client.user_metadata) {
      if (client.user_metadata.full_name) return client.user_metadata.full_name;
      if (client.user_metadata.name) return client.user_metadata.name;
      
      const name = `${client.user_metadata.first_name || ''} ${client.user_metadata.last_name || ''}`.trim();
      if (name) return name;
    }
    
    return client.email || "Unknown Client";
  };

  const getClientDetails = (client?: ClientTherapistRelationship['client']) => {
    if (!client) return { company: "", fullName: "" };
    
    let company = "";
    let fullName = "";
    
    if (client.profile) {
      company = client.profile.company || "";
      
      if (client.profile.first_name || client.profile.last_name) {
        fullName = `${client.profile.first_name || ''} ${client.profile.last_name || ''}`.trim();
      }
    }
    
    if (!fullName && client.user_metadata) {
      if (client.user_metadata.first_name || client.user_metadata.last_name) {
        fullName = `${client.user_metadata.first_name || ''} ${client.user_metadata.last_name || ''}`.trim();
      }
      
      if (!company && client.user_metadata.company) {
        company = client.user_metadata.company;
      }
    }
    
    return { company, fullName };
  };

  return {
    formatDate,
    getClientDisplayName,
    getClientDetails
  };
};
